<template>
  <div>
    <FITModal :title="$t('crm.lead.create.header')" reference="leadConfirmationModal" ref="confirmation" @click="confirm">
      <div slot="body">
        {{ $t('crm.lead.create.confirmation') }}
      </div>
    </FITModal>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="8">
            <p class="h5">{{ $t('crm.lead.create.header') }}</p>
          </b-col>
          <b-col cols="4" class="text-right" v-if="ID !== null && permissionLevel < 5.5">
            <p class="h5" @click="updateLocked">
              <i style="cursor: pointer" :class="{ 'fa' : true, 'fa-lock' : locked, 'fa-unlock' : !locked }"></i></p>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <b-row>
          <b-col cols="8">
            <FITDatePicker field="dateOfContact" :label="$t('crm.lead.create.dateOfContact')" :placeholder="$t('crm.lead.create.dateOfContact')" v-model="form.dateOfContact" :disabled="locked"></FITDatePicker>
            <FITSelect field="type" :label="$t('crm.lead.create.type')" :placeholder="$t('crm.lead.create.type')" :options="leadTypes" v-model="form.type" :width="10" :disabled="locked"></FITSelect>
            <FITTextInput field="name" :label="$t('crm.lead.create.name')" :placeholder="$t('crm.lead.create.name')" v-model.trim="form.name" :disabled="locked"></FITTextInput>
            <FITSelect field="gender" :label="$t('crm.lead.create.gender')" :placeholder="$t('crm.lead.create.gender')" :options="genders" v-model="form.gender" :width="10" :disabled="locked"></FITSelect>
            <FITSelect field="leadLevel" :label="$t('crm.lead.create.level')" :placeholder="$t('crm.lead.create.level')" :options="leadLevels" v-model="form.leadLevel" :width="10" :disabled="locked"></FITSelect>
            <FITSelect field="status" :label="$t('crm.lead.create.status')" :placeholder="$t('crm.lead.create.status')" :options="leadStatus" v-model="form.status" :width="10" :disabled="locked"></FITSelect>
            <FITTextInput field="phoneNumber" :label="$t('crm.lead.create.phoneNumber')" :placeholder="$t('crm.lead.create.phoneNumber')" v-model="form.phoneNumber" :disabled="locked"></FITTextInput>
            <FITTextInput field="identityCardNo" :label="$t('crm.lead.create.identityCardNo')" :placeholder="$t('crm.lead.create.identityCardNo')" v-model="form.identityCardNo" :disabled="locked"></FITTextInput>
            <FITTextarea field="remarks" :label="$t('crm.lead.create.remarks')" :placeholder="$t('crm.lead.create.remarks')" v-model="form.remarks" :disabled="locked"></FITTextarea>
            <FITTextarea field="activityLog" :label="$t('crm.lead.create.activityLog')" :placeholder="$t('crm.lead.create.activityLog')" v-model="form.activityLog" :disabled="locked"></FITTextarea>
          </b-col>
          <b-col cols="4">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8" class="text-right">
            <FITButton class="mr-2" v-if="ID !== null && permissionLevel < 5.5" size="md" variant="info" :text="$t('crm.lead.convertToCustomer')" faIcon="fa-user-plus" @click="routeToCustomerCreate"></FITButton>
            <FITButton v-if="permissionLevel < 5.5" class="min-width-button" size="md" :variant="(ID !== null) ? 'warning' : 'primary'" text="Submit" @click="validationCheck" :disabled="locked"></FITButton>
          </b-col>
        </b-row>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import {
  FITTextInput,
  FITAutoSearch,
  FITSelect,
  FITDatePicker,
  FITTextarea,
  FITButton,
  FITFormCard,
  FITModal
} from '@/components';

import {  mapState, mapGetters } from 'vuex'

import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'LeadCreate',
  components: {
    FITTextInput,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    FITButton,
    FITFormCard,
    FITModal
  },

  props: {
    ID: {
      type: Number,
      default: null
    }
  },

  created() {
  // Get Validation Rule
    let validationType = 'create'
      if (this.ID) {
        validationType = 'edit';
      }
    this.$store.commit('Validation/validationReset');
    this.$store.dispatch('Validation/getValidationRule',`/crm/lead/${validationType}`);
    this.$store.commit('Validation/setAlertMsg',{alertMsg: this.$t("validation.alertMsg.error")});

    this.$store.dispatch('getAllSelections', 'lead')
      .then((json) => {
        // console.log(json)
        this.$store.commit({ type: 'Crm/setSelections', selection: json.data });
        if (this.ID) {
          this.$store.dispatch('Crm/getLeadList', {
            ID: this.ID
          }).then((json) => {
            if (json.data.list.length > 0) {
              Vue.set(this, 'locked', true);
              Vue.set(this, 'form', json.data.list[0]);
            }
          })
        }
      })
      .catch((err) => {
        console.error(err);
      })
  },

  computed: {
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    ...mapGetters('Crm', [
      'getTranslated'
    ]),
   ...mapState({
        'vuexFinalResult': state => state.Validation.validationFinalResult,
      }),
    leadLevels() {
      return this.getTranslated(this.$i18n.locale, 'leadLevel');
    },

    leadTypes() {
      return this.getTranslated(this.$i18n.locale, 'type');
    },

    leadStatus() {
      return this.getTranslated(this.$i18n.locale, 'status');
    }
  },

  methods: {
    openModal() {
      this.$refs.confirmation.openModal();
    },
      validationCheck(){
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },

    routeToCustomerCreate() {
      this.$router.push({
        name: 'Create Customer',
        params: { lead: this.form }
      });
    },

    updateLocked() {
      Vue.set(this, 'locked', !this.locked);
    },

    confirm(confirmed) {
      if (confirmed) {
        if (this.ID) {
          this.editLead();
          return;
        }
        this.createLead();
      }
    },

    createLead() {
      this.$store.dispatch('Crm/createLead', this.form)
        .then((json) => {
          this.$router.replace({
            name: 'List Lead',
            params: {
              createSuccess: true
            }
          })
        }).catch((err) => {
          console.error(err);
        });
    },

    editLead() {
      this.$store.dispatch('Crm/editLead', this.form)
        .then((json) => {
          this.$router.replace({
            name: 'List Lead',
            params: {
              createSuccess: true
            }
          });
        }).catch((err) => {
          console.error(err);
        });
    }
  },
  watch:{
      vuexFinalResult(newData,oldData){
       let result = newData;
       // console.log("Final Result: "+newData);
      if(result){
        this.openModal();
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset',true);
      }
    }
  },


  data() {
    return {
      locked: false,
      genders: [{
        text: 'Male',
        value: 'M'
      }, {
        text: 'Female',
        value: 'F'
      }],

      form: {
        name: '',
        phoneNumber: '',
        identityCardNo: '',
        remarks: '',
        activityLog: '',
        dateOfContact: moment().format('YYYY-MM-DD'),
        leadLevel: 'L',
        type: 'C',
        gender: 'F',
        status: 'W'
      }
    }
  }
}

</script>
<style>
.min-width-button {
  min-width: 80px;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Lead/LeadCreate.vue